import { createStore } from 'vuex'
import auth from './modules/auth'
import shoes from './modules/shoes'
import cart from './modules/cart'
import customize from './modules/customize'

export default createStore({
  modules: {
    auth,
    shoes,
    cart,
    customize
  }
}) 